'use client';

import React, { useState, useEffect } from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import axios from "axios";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../ui/ToastContext";
import { BsFillEnvelopeFill } from "react-icons/bs";
import { BsFillTelephoneFill } from "react-icons/bs";
import { API_URL } from "../../config";

declare module "../../config" {
    export const API_URL: string;
}

export function AccountCreateForm(): React.JSX.Element {
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [Rol, setRol] = useState([]);
    const [prod, setProd] = useState([]);
    const [userData, setUserData] = useState([]);

    const [value, setValue] = React.useState<Option[] | null>(null);
    const [valueuser, setValueuser] = React.useState<OptionUser[] | null>(null);
    const [mail, setMail] = useState('');
    // const [phone, setPhone] = useState({ formatted: '', number: 0 });
    const [phone, setPhone] = useState('');
    const [Nume_prenume, setNume_prenume] = useState("");
    const [Login, setLogin] = useState("");
    const [Parola, setParola] = useState("");
    const [id, setId] = useState("");
    const [roleError, setRoleError] = useState(false);
    const [nameError, setnameError] = useState(false);
    const [logError, setlogError] = useState(false);
    const [pasError, setpasError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [defaultOption, setDefaultOption] = useState("");  // Default value should be role_id
    const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
    const getJwtFromCookies = () => {
        const cookies = document.cookie.split("; ");
        const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
        return tokenCookie ? tokenCookie.split("=")[1] : null;
    };

    //const token = getJwtFromCookies();

    const token = localStorage.getItem('jwtToken');


    useEffect(() => {
        const timer = setTimeout(() => {
            setShowGrid(false); // După 1 secundă, comutăm pe grid
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/rol`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setRol(response.data);
                // //////////////////////////////console.log(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/producer`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setProd(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/users`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setUserData(response.data)

                const users = response.data;

                // Find the user with the highest user_id
                const latestUser = users.reduce((max, user) => (user.user_id > max.user_id ? user : max), users[0]);

                // Log the latest user ID
                //////////////////////////////console.log("Latest user ID:", latestUser.user_id);
                setId(latestUser.user_id)
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);

            });
    }, []);

    interface Role {
        role_id: number;
        role_name: string;
    }

    const dropdownOptions = Rol.map((role: Role) => ({
        value: role.role_id,
        label: role.role_name
    }));

    const _onSelect = (selectedOption) => {
        //////////////////////////////console.log(selectedOption);
        setDefaultOption(selectedOption);  // Set the selected option
    };

    interface Option {
        producer_id: number;
        producer_name: string;
    }

    const organizerOptions: Option[] = prod.map((role: Option) => ({
        producer_id: role.producer_id,
        producer_name: role.producer_name,
    }));

    interface OptionUser {
        user_id: number;
        user_name_surname: string;
    }

    const organizerOptionsuser: OptionUser[] = userData.map((role: OptionUser) => ({
        user_id: role.user_id,
        user_name_surname: role.user_name_surname,
    })).filter((value, index, self) =>
        index === self.findIndex((t) => t.user_id === value.user_id)
    );

    const handleChange = (e) => {
        setNume_prenume(e.target.value);
    };

    const handleChangelog = (e) => {
        setLogin(e.target.value);
    };

    const handleChangepas = (e) => {
        setParola(e.target.value);
    };

    const handleChangem = (e) => {
        const email = e.target.value;
        setMail(email);

        // Validarea email-ului cu regex
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9.-]+$/;
        if (!emailRegex.test(email)) {
            setEmailError(true);  // Setează eroarea
        } else {
            setEmailError(false);  // Șterge eroarea dacă este valid
        }
    };

    const handleChangep = (e) => {
        const value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            setPhone(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (Nume_prenume === "" || Login === "" || Parola === "") {
            setnameError(Nume_prenume === "" ? true : false)
            setpasError(Parola === "" ? true : false)
            setlogError(Login === "" ? true : false)

            //////////////////////////////console.log("error")
            return;
        }

        if (!['1', '2', '3'].includes(defaultOption)) {
            setRoleError(true); // Setează eroarea
            //////////////////////////////console.log('oprit');
            return; // Oprește execuția formularului
        }
        //////////////////////////////console.log("num", defaultOption);
        let allRequestsSuccessful = true;  // Flag pentru succesul tuturor cererilor



        try {
            await axios.post(`${API_URL}/api/users`, {
                user_name_surname: Nume_prenume,
                login: Login,
                password: Parola,
                mail: mail, phone: phone

            });
        } catch (error) {
            console.error(error);
            alert("Eroare la inserarea datelor");
            allRequestsSuccessful = false; // Setează flag-ul la false în caz de eroare
        }

        const response = await axios.get(`${API_URL}/api/users`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        const institutionId = response.data.find((i) => i.user_name_surname === Nume_prenume).user_id;

        try {
            await axios.post(`${API_URL}/api/rol`, {
                user_id: institutionId, role_id: defaultOption
            });
        } catch (error) {
            console.error(error);
            alert("Eroare la inserarea datelor");
            allRequestsSuccessful = false; // Setează flag-ul la false în caz de eroare
        }

        try {
            if (value && value.length > 0) {
                // Prepare an array of entries to be sent in one request
                const entries = value.map(producerId => ({
                    user_id: institutionId,
                    producer_or_producer_group_id: producerId.producer_id,
                    relation_type_id: 1
                }));

                // Send the array of entries to the new API
                await axios.post(`${API_URL}/api/repprod`, {
                    entries: entries
                });
                //////////////////////////////console.log("Entries successfully sent:", entries);
            }
        } catch (error) {
            console.error(error);
            allRequestsSuccessful = false; // Set the flag to false in case of an error
        }

        try {
            if (valueuser && valueuser.length > 0) {
                const subordinateUserIds = valueuser.map(userId => userId.user_id);

                // Send the array of subordinate_user_ids in the request
                await axios.post(`${API_URL}/api/manageusers`, {
                    manager_user_id: institutionId,
                    subordinate_user_ids: subordinateUserIds
                });

                //////////////////////////////console.log("Users processed: ", subordinateUserIds);
            } else {
                //////////////////////////////console.log("No users selected or valueuser is null");
            }
        } catch (error) {
            console.error(error);
            allRequestsSuccessful = false; // Set the flag to false if there is an error
        }

        // Dacă toate cererile au fost cu succes, afișează div-ul
        if (allRequestsSuccessful) {
            handleClose();
            showToast({
                message: "Datele au fost salvate cu succes!",
                type: "success",
                icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
            });
        } else {
            showToast({
                message: "Eroare la inserarea datelor!",
                type: "error",
                icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
            });
        }
    };

    const handleClose = () => {
        navigate(-1); // Use navigate to go back
    };

    const isDarkMode = document.documentElement.classList.contains('dark');

    return (
        <div >
            {showGrid ? (
                <div className="flex flex-row gap-2">
                    <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
                    <div className="flex flex-col gap-2">
                        <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
                    </div>
                </div>
            ) : (
                <form
                    onSubmit={(event) => {
                        event.preventDefault();
                    }}
                >
                    <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                        <CardHeader subheader="Informatia poate fii modificata" title="Profil" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                        <Divider className="dark:bg-gray-400" />
                        <CardContent>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div className="relative">
                                    <label
                                        className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                    >
                                        Nume Prenume
                                    </label>
                                    <input
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${nameError ? 'border-red-500' : ''}`}
                                        type="text"
                                        name="firstName"
                                        placeholder="Nume Prenume"
                                        value={Nume_prenume}
                                        onChange={handleChange}
                                        required
                                    />
                                    {nameError && <p className="text-red-500 text-sm">Numele este obligatoriu.</p>}
                                </div>

                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Rol</label>
                                    <select
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${roleError ? 'border-red-500' : ''}`}  // Adaugă clasa pentru eroare
                                        value={defaultOption}
                                        onChange={(e) => _onSelect(e.target.value)}
                                    >
                                        <option value="" disabled>Alege rol</option>
                                        {dropdownOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    {roleError && <p className="text-red-500 text-sm">Rolul este obligatoriu.</p>}
                                </div>

                                <div className="relative">
                                    <label
                                        className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                    >
                                        login
                                    </label>
                                    <input
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${logError ? 'border-red-500' : ''}`}
                                        type="text"
                                        name="login"
                                        placeholder="Login"
                                        value={Login}
                                        onChange={handleChangelog}
                                    />
                                    {logError && <p className="text-red-500 text-sm">Loginul este obligatoriu.</p>}

                                </div>

                                <div className="relative">
                                    <label
                                        className={`absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100 `}
                                    >
                                        Parola
                                    </label>
                                    <input
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${pasError ? 'border-red-500' : ''}`}
                                        type="password"
                                        name="parola"
                                        placeholder="Parola"
                                        value={Parola}
                                        onChange={handleChangepas}
                                    />
                                    {pasError && <p className="text-red-500 text-sm">Parola este obligatorie.</p>}

                                </div>

                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                                        Posta electronica
                                    </label>
                                    <BsFillEnvelopeFill className="absolute left-3 top-6 transform -translate-y-1/2 text-gray-400" />
                                    <input
                                        className={`pl-10 w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${emailError ? 'border-red-500' : ''}`}
                                        type="text"
                                        name="email"
                                        placeholder="Posta@electronica.com"
                                        value={mail}
                                        onChange={handleChangem}
                                    />
                                    {emailError && <p className="text-red-500 text-sm">Email invalid! Trebuie să conțină @ și un domeniu valid (ex: .com sau .ru).</p>}
                                </div>

                                <div className="relative">
                                    <label
                                        className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                    >
                                        Numar de telefon
                                    </label>
                                    <BsFillTelephoneFill className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                    <input
                                        className="pl-10 w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                                        type="text"
                                        name="phone"
                                        // value={phone.formatted || ''}
                                        value={phone || ''}
                                        placeholder="+373..."
                                        onChange={handleChangep}
                                        maxLength={9}
                                    />

                                </div>

                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10" >
                                        Acces producatori
                                    </label>

                                    <Select
                                        options={organizerOptions}
                                        placeholder="Select accesul la producatori..."
                                        isMulti
                                        classNamePrefix="react-select"
                                        value={value}
                                        onChange={(selected) => setValue(selected as Option[] | null)}
                                        getOptionLabel={(e) => e.producer_name}
                                        getOptionValue={(e) => String(e.producer_id)}
                                        menuPortalTarget={document.body}

                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                padding: '0.75rem',
                                                borderRadius: '0.375rem',
                                                borderColor: '#424242',
                                                boxShadow: 'none',
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                                zIndex: 0,
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                                color:  'black',
                                            }),
                                            singleValue: provided => ({
                                                ...provided,
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                            })

                                        }}
                                    />
                                </div>

                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10" >
                                        Acces utilizatori
                                    </label>
                                    <Select
                                        options={organizerOptionsuser}
                                        placeholder="Select accesul la utilizatori..."
                                        isMulti
                                        classNamePrefix="react-select"
                                        value={valueuser}
                                        onChange={(selected) => setValueuser(selected as unknown as OptionUser[] | null)}
                                        getOptionLabel={(e) => e.user_name_surname}
                                        getOptionValue={(e) => String(e.user_id)}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                padding: '0.75rem',
                                                borderRadius: '0.375rem',
                                                borderColor: '#424242',
                                                boxShadow: 'none',
                                                // zIndex: 9999,
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                                color:  'black' ,
                                            }),
                                            singleValue: provided => ({
                                                ...provided,
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                            })

                                        }}
                                    />
                                </div>
                            </div>

                        </CardContent>
                        <Divider className="dark:bg-gray-400" />
                        <CardActions sx={{ justifyContent: 'flex-end' }}>
                            <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white" onClick={handleSubmit}
                            >
                                <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                                <span className="//max-xs:sr-only">Salveaza detaliile</span>

                            </button>
                        </CardActions>
                    </Card>
                </form>
            )}
        </div>
    );
}
